// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.portal-icon[data-v-6b5d9a96] {\n\tdisplay: inline-block;\n\tflex: 0 0 auto;\n\tvertical-align: middle;\n}\n", ""]);
// Exports
module.exports = exports;
